module.exports = __webpack_public_path__ + "static/media/flashcards.2057cc16.svg";